// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_6x-3";
export var contentContainer = "_6x-0";
export var editorContainer = "_6x-1";
export var quillInputForm = "_6x-2";
export var zoneDivider = "_6x-4";